import { WrapperOrganisationPermissions } from "../../../models";

/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
const getWrappedPermissionsForOrgUser = (
  permissions: any
): WrapperOrganisationPermissions | null => {
  if (permissions === null || permissions === undefined) {
    return null;
  }

  const wrappedPermissions: WrapperOrganisationPermissions = {
    can_create_organisation_user: permissions?.can_create_organisation_user,
    can_read_organisation_user: permissions?.can_read_organisation_user,
    can_delete_organisation_user: permissions?.can_delete_organisation_user,
    can_update_organisation_user: permissions?.can_update_organisation_user,
    can_read_organisation_user_logo: permissions?.can_read_user_logo,
    is_active_user: permissions?.is_active_user,
    can_create_organisation: permissions?.can_create_organisation,
    can_read_organisation: permissions?.can_read_organisation,
    can_update_organisation: permissions?.can_update_organisation,
    can_delete_organisation: permissions?.can_delete_organisation,
    can_read_organisation_logo: permissions?.can_read_organisation_logo,
  };

  return wrappedPermissions;
};

export default getWrappedPermissionsForOrgUser;
